<template>
  <nav class="visible-xs-block navbar navbar-default">
      <div class="container">
        <div class="navbar-header">
            <button type="button"
                class="navbar-toggle"
                data-toggle="collapse"
                data-target="#glo-navbar-collapse"
            >
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>

	    </div>
        <div class="collapse navbar-collapse" id="glo-navbar-collapse">
            <ul class="nav navbar-nav">
                <li><a v-link="{ path: getUrlStr('/') }">{{getStrRes('ML_Home')}}</a></li>
                <li><a v-link="{ path: getUrlStr('/about') }">{{getStrRes('ML_About')}}</a></li>
                <li><a v-link="{ path: getUrlStr('/products/accessories') }">{{getStrRes('ML_Products')}}</a></li>
                <li><a v-link="{ path: getUrlStr('/oem') }">{{getStrRes('ML_OEM')}}</a></li>
                <li><a v-link="{ path: getUrlStr('/amscontrols/ams-xl200-ctrls') }">{{getStrRes('ML_AMSControls')}}</a></li>
                <li><a v-link="{ path: getUrlStr('/contact') }">{{getStrRes('ML_ContactUs')}}</a></li>
            </ul>
        </div>
      </div>
  </nav>
  <div>
    <div class="container">
      <div class="row" style="padding-top: 8px;">
        <div class="col-sm-5">
          <!--<a v-link="{ path: '/' }">-->
            <img src="/assets/img/allmac_logo.png" style="height: 54px;">
          
          <!--</a>-->
          <!--<a href="https://www.youtube.com/user/amscontrols">-->
            <img
                style="margin-left: 13px; height: 33px;"
                src="/assets/img/formia_logo.png"
            >
          <!--</a>-->
          
            <img
                style="margin-left: 13px; height: 28px;"
                src="/assets/img/ams_logo.png"
            >
        </div>
        <div class="col-sm-7">
            <div>
                <form class="form-inline">
                    <ul class="list-inline pull-right" style="padding-left: 3px;">
                        <li>
                            <div style="white-space: nowrap;">
                                <a target="_blank" href="javascript: void(0)">
                                    <img src="/assets/img/icon/linkedin.png" style="width: 30px;" >
                                </a>
                                <a target="_blank" href="javascript: void(0)">
                                    <img src="/assets/img/icon/twitter.png"  style="width: 30px;">
                                </a>
                                <a target="_blank" href="javascript: void(0)">
                                    <img src="/assets/img/icon/youtube.png"  style="width: 30px;">
                                </a>
                                <a target="_blank" href="javascript: void(0)">
                                    <img src="/assets/img/icon/facebook.png" style="width: 30px;" >
                                </a>
                                <a v-link="{ path: '/en' }"><img src="/assets/img/icon/flag_gb.png" style="width: 42px;"></a>
                                <a v-link="{ path: '/spa' }"><img src="/assets/img/icon/flag_es.png" style="width: 42px;"></a>
                                <a v-link="{ path: '/de' }"><img src="/assets/img/icon/flag_ge.png" style="width: 42px;"></a>
                                <a v-link="{ path: '/ru' }"><img src="/assets/img/icon/flag_ru.png" style="width: 42px; border: 1px solid gray;"></a>
                            </div>
                        </li>
                    </ul>
                    <!--
                    <div class="input-group hidden-xs pull-right">
                        <input type="text" class="form-control" :placeholder.once="getStrRes('ML_Search') + '...'"
                            @keyup.enter="search" v-model="searchText"
                        >
                        <span class="input-group-btn">
                            <input type="button" class="btn btn-default" :value.once="getStrRes('ML_Search')" @click="search">
                        </span>
                    </div>
                    -->
                    <div class="pull-right">
                        <select
                            class="form-control"
                            v-model="searchText"
                            @change="search"
                        >
                            <option value=""> </option>
                            <option disabled> -= {{getStrRes('ML_FORMIA_SOLUTIONS')}} =- </option>
                            <option value="Twin Servo Press Tile Line">{{getStrRes('ML_TE23/1100')}}</option>
                            <option value="Single Servo Press Tile Line">{{getStrRes('ML_S_SPTL')}}</option>
                            <!--<option value="Roofing Solutions">{{getStrRes('ML_ROOFING_SOLS')}}</option>-->
                            <option value="Cladding Solutions">{{getStrRes('ML_Cladding_Solutions')}}</option>
                            <option value="Framing Solutions">{{getStrRes('ML_Framing_Solutions')}}</option>
                            <option value="Other Solutions">{{getStrRes('ML_Other_Solutions')}}</option>
                            <option disabled> -= {{getStrRes('ML_AMSControls')}} =- </option>
                            <option value="AMS XL200 Controls">{{getStrRes('ML_AMSControls')}}</option>
                            <option value="Pathfinder Controls">{{getStrRes('ML_AMSPathFinderCtrls')}}</option>
                            <option value="Eclipse">{{getStrRes('ML_EclipseSoft')}}</option>
                            <option disabled> -= {{getStrRes('ML_Products')}} =- </option>
                            <option value="C&U Purlin Roll Forming Machine">{{getStrRes('ML_CUPRFM')}}</option>
                            <option value="C&Z Purlin Roll Forming Machine">{{getStrRes('ML_CZPRFM')}}</option>
                            <option value="Tile Roll Forming Machine">{{getStrRes('ML_TiRFM')}}</option>
                            <option value="Stud And Track Forming Machine">{{getStrRes('ML_SNTFM')}}</option>
                            <option value="Ridge Cap Roll Forming Machine">{{getStrRes('ML_RCRFM')}}</option>
                            <option value="Tube Roll Forming Machine">{{getStrRes('ML_TuRFM')}}</option>
                            <option value="Metal Deck Roll Forming Machine">{{getStrRes('ML_MDRFM')}}</option>
                            <option value="Roof Panel Forming Machine">{{getStrRes('ML_RPFM')}}</option>
                            <option value="Panel Roll Forming Machine">{{getStrRes('ML_PRFM')}}</option>
                            <option value="Folding Machine">{{getStrRes('ML_FM')}}</option>
                            <option value="Auxiliary Equipment">{{getStrRes('ML_AE')}}</option>
                            <option disabled> -= {{getStrRes('ML_OEM')}} =- </option>
                            <option value="Oem">{{getStrRes('ML_OEM')}}</option>
                            <option disabled> -= {{getStrRes('ML_ContactUs')}} =- </option>
                            <option value="Contact Us">{{getStrRes('ML_ContactUs')}}</option>
                        </select>
                    </div>
                </form>
            </div>
            
            
            <div class="clearfix"></div>
            
          
        </div>
        
      </div>
      <div class="row hidden-xs">
        <ul class="row nav nav-pills pull-right">
            <li>
                <a v-link="{ path: getUrlStr('/') }" @click="toggleActive">{{getStrRes('ML_Home')}}</a>
            </li>
            <li>
                <a v-link="{ path: getUrlStr('/about/ALLMAC') }" @click="toggleActive">{{getStrRes('ML_About')}}</a>
            </li>
            <li :class="{ 'active': productsActive }">
                <!-- <a href="javascript: void(0)" @click="toggleActive('isProducts')">{{getStrRes('ML_Products')}}<span class="caret"></span></a> -->
                <a v-link="{ path: getUrlStr('/products/stud-and-track-forming-machine') }">{{getStrRes('ML_Products')}}<span class="caret"></span></a>
            </li>
            <li>
                <a v-link="{ path: getUrlStr('/oem') }" @click="toggleActive">{{getStrRes('ML_OEM')}}</a>
            </li>
            <li :class="{ 'active': amsCtrlsActive }">
                <!-- <a href="javascript: void(0)" @click="toggleActive('isAMSControls')">{{getStrRes('ML_AMSControls')}}<span class="caret"></span></a> -->
                <a v-link="{ path: getUrlStr('/amscontrols/ams-xl200-ctrls') }">{{getStrRes('ML_AMSControls')}}<span class="caret"></span></a>
            </li>
            <li>
                <a v-link="{ path: getUrlStr('/contact') }" @click="toggleActive">{{getStrRes('ML_ContactUs')}}</a>
            </li>
        </ul>
    </div>
    </div>
  </div>
  <div>
        <div v-show="productsActive || formiaSolsActive" class="am-nav-wrap hidden-xs" transition="expand">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <h3>
                            {{getStrRes('ML_Products')}}
                        </h3>
                        <div  v-show="formiaSolsActive">
                            <img src="/assets/img/formia_logo.png" style="height: 34px;">
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div
                            style="
                                margin-left: 5px; margin-bottom: 15px;
                                font-weight: bold;
                            "
                            v-show="productsActive"
                        >
                            <a
                                class="btn btn-lg btn-primary"
                                style="font-size: 24px;"
                                v-link="getUrlStr('/formia-solutions/te23_1100')"
                            >
                                <img src="/assets/img/formia_logo.png" style="height: 34px;">
                                {{getStrRes('ML_FORMIA_SOLUTIONS')}}
                                <span class="glyphicon glyphicon-chevron-right"></span>
                            </a>
                        </div>
                        <div
                            style="
                                margin-left: 5px; margin-bottom: 15px;
                                font-weight: bold;
                            "
                            v-show="formiaSolsActive"
                        >
                            <a
                                class="btn btn-lg btn-primary"
                                v-link="getUrlStr('/products/stud-and-track-forming-machine')"
                            >
                                <span class="glyphicon glyphicon-chevron-left"></span>
                                {{getStrRes('ML_Products')}}
                            </a>
                        </div>
                        <div
                            v-show="!formiaSolsActive"
                        >
                            <div class="col-sm-4">
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/cu-purlin-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/pul.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/cu-purlin-roll-forming-machine') }">
                                                {{getStrRes('ML_CUPRFM')}}
                                            </a>
                                        </h5>
                                        <p>
                                            <video-link link="https://youtu.be/pSAPMpWurCU"></video-link>
                                        </p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/cz-purlin-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/cz-pul.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/cz-purlin-roll-forming-machine') }">
                                                {{getStrRes('ML_CZPRFM')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/tile-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/tl.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/tile-roll-forming-machine') }">
                                                {{getStrRes('ML_TiRFM')}}
                                            </a>
                                        </h5>
                                        <p>
                                            <video-link link="https://youtu.be/bqGtfBO9rmI"></video-link>
                                        </p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/stud-and-track-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/snt.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/stud-and-track-forming-machine') }">
                                                {{getStrRes('ML_SNTFM')}}
                                            </a>
                                        </h5>
                                        <p>
                                            <video-link link="https://youtu.be/1TRjM0rgyLQ"></video-link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/ridgecap-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/rl.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/ridgecap-roll-forming-machine') }">
                                                {{getStrRes('ML_RCRFM')}}
                                            </a>
                                        </h5>
                                        <p>
                                            <video-link link="https://youtu.be/YQEvVJpqWok"></video-link>
                                        </p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/tube-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/amt160.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/tube-roll-forming-machine') }">
                                                {{getStrRes('ML_TuRFM')}}
                                            </a>
                                        </h5>
                                        <p>
                                            <video-link link="https://youtu.be/jGuJdwVZBYA"></video-link>
                                        </p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/deck-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/dl.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/deck-roll-forming-machine') }">
                                                {{getStrRes('ML_MDRFM')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/roof-panel-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/rpfm.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/roof-panel-forming-machine') }">
                                                {{getStrRes('ML_RPFM')}}
                                            </a>
                                        </h5>
                                        <p><video-link link="https://youtu.be/H6lau5F_s8g"></video-link></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/panel-roll-forming-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/pl.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/panel-roll-forming-machine') }">
                                                {{getStrRes('ML_PRFM')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/folding-machine') }">
                                            <img class="media-object" src="/assets/img/home/products/fd.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/folding-machine') }">
                                                {{getStrRes('ML_FM')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/products/accessories') }">
                                            <img class="media-object" src="/assets/img/home/products/acc.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/products/accessories') }">
                                                {{getStrRes('ML_AE')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-show="formiaSolsActive"
                        >
                            <div
                                class="col-sm-6"
                                style="margin-bottom: 25px;"
                            >
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/te23_1100') }">
                                            <img class="media-object" src="/assets/img/home/formia/te23_1100.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/formia-solutions/te23_1100') }">
                                                {{getStrRes('ML_TE23/1100')}}
                                            </a>
                                        </h5>
                                        <p><video-link link="https://youtu.be/aCuOvLNbRNg"></video-link></p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-sm-6"
                                style="margin-bottom: 25px;"
                            >
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/single-servo-press-tile-line') }">
                                            <img class="media-object" src="/assets/img/home/formia/ssptl.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/formia-solutions/single-servo-press-tile-line') }">
                                                {{getStrRes('ML_S_SPTL')}}
                                            </a>
                                        </h5>
                                        <p><video-link link="https://youtu.be/_yGMlgsZP8c"></video-link></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                
                                <div style="margin: 5px; font-weight: bold;">
                                    <span class="glyphicon glyphicon-bookmark"></span>
                                    {{getStrRes('ML_ROOFING_SOLS')}}
                                </div>
                                
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/other-solutions') }">
                                            <img class="media-object" src="/assets/img/home/formia/os.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/formia-solutions/other-solutions') }">
                                                {{getStrRes('ML_Other_Solutions')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                
                                <!--
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/other-solutions') }">
                                            <img class="media-object" src="/assets/img/home/formia/os.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            {{getStrRes('ML_Other_Solutions')}}
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                                -->
                            </div>
                            <div class="col-sm-4">
                                <div style="margin: 5px; font-weight: bold;">
                                    <span class="glyphicon glyphicon-bookmark"></span>
                                    {{getStrRes('ML_Cladding_Solutions')}}
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/cladding-solutions') }">
                                            <img class="media-object" src="/assets/img/home/formia/cls.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/formia-solutions/cladding-solutions') }">
                                                {{getStrRes('ML_Cladding_Solutions')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div style="margin: 5px; font-weight: bold;">
                                    <span class="glyphicon glyphicon-bookmark"></span>
                                    {{getStrRes('ML_Framing_Solutions')}}
                                </div>
                                <div class="media">
                                    <div class="media-left">
                                        <a v-link="{ path: getUrlStr('/formia-solutions/framing-solutions') }">
                                            <img class="media-object" src="/assets/img/home/formia/fs.png" >
                                        </a>
                                    </div>
                                    <div class="media-body">
                                        <h5 class="media-heading">
                                            <a v-link="{ path: getUrlStr('/formia-solutions/framing-solutions') }">
                                                {{getStrRes('ML_Framing_Solutions')}}
                                            </a>
                                        </h5>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="amsCtrlsActive" class="am-nav-wrap hidden-xs" transition="expand">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <h4>
                            {{getStrRes('ML_AMSControlsIntro')}}
                        </h4>
                        <p>
                            <a href="http://www.amscontrols.com/about-us/partners/">{{getStrRes('ML_AMSControlLink')}}</a>
                        </p>
                        <div>
                            <!--<h4>Certification</h4>-->
                            <a class="image-link" v-link="{ path: getUrlStr('/amscontrols/certification') }">
                                <img src="/assets/img/ams_cert_logo.png"><br>
                                <span>{{getStrRes('ML_AMSDealerCertification')}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col-sm-4">
                                <!--<h4>Controls</h4>-->
                                <a class="image-link" v-link="{ path: getUrlStr('/amscontrols/ams-xl200-ctrls') }">
                                    <img src="/assets/img/xl200.jpg"><br>
                                    <span>{{getStrRes('ML_AMSControls')}}</span>
                                </a>
                                
                            </div>
                            <div class="col-sm-4">
                                <!--<h4>Software</h4>-->
                                <a class="image-link" v-link="{ path: getUrlStr('/amscontrols/pathfinder') }">
                                    <img src="/assets/img/Pathfnder-Edge1.png"><br>
                                    <span>{{getStrRes('ML_AMSPathFinderCtrls')}}</span>
                                </a>
                                
                            </div>
                            <div class="col-sm-4">
                                <!--<h4>Certification</h4>-->
                                <a class="image-link" v-link="{ path: getUrlStr('/amscontrols/eclipse') }">
                                    <img src="/assets/img/Eclipse_AMS11.jpg"><br>
                                    <span>{{getStrRes('ML_EclipseSoft')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<div v-show="navFlags.isContactUs" class="am-nav-wrap" transition="expand">
            <div class="container">
                
            </div>
        </div>-->
        <!--<div v-show="navFlags.isNews" class="am-nav-wrap" transition="expand">
            <div class="container">
                
            </div>
        </div>-->

  </div>
</template>

<script>
import VideoLink from '../VideoLink.vue'
import {getStrRes, getUrlStr} from '../../util/MultiLang.js'

//English
const EN_STR_RES_MAP = new Map
EN_STR_RES_MAP.set("ML_Search", "Search")
EN_STR_RES_MAP.set("ML_Home", "Home")
EN_STR_RES_MAP.set("ML_About", "About us")
EN_STR_RES_MAP.set("ML_Products", "Products")
EN_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS", "FORMIA’S SOLUTIONS")
EN_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS_LC", "Formia's Solutions")
EN_STR_RES_MAP.set("ML_MachineVideo", "Machine video")
EN_STR_RES_MAP.set("ML_CUPRFM", "C&U Purlin Roll Forming Machine")
EN_STR_RES_MAP.set("ML_CZPRFM", "C&Z Purlin Roll Forming Machine")
EN_STR_RES_MAP.set("ML_TiRFM", "Tile Roll Forming Machine")
EN_STR_RES_MAP.set("ML_RCRFM", "Ridge Cap Roll Forming Machine")
EN_STR_RES_MAP.set("ML_TuRFM", "Tube Roll Forming Machine")
EN_STR_RES_MAP.set("ML_MDRFM", "Metal Deck Roll Forming Machine")
EN_STR_RES_MAP.set("ML_PRFM", "Panel Roll Forming Machine")
EN_STR_RES_MAP.set("ML_FM", "Folding Machine")
EN_STR_RES_MAP.set("ML_AE", "Auxiliary Equipment")
EN_STR_RES_MAP.set("ML_Roofing_Solutions", "Roofing Solutions")

EN_STR_RES_MAP.set("ML_TE23/1100", "Twin Servo Press Tile Line")
EN_STR_RES_MAP.set("ML_S_SPTL", "Single Servo Press Tile Line")
EN_STR_RES_MAP.set("ML_ROOFING_SOLS", "Roofing Solutions")
EN_STR_RES_MAP.set("ML_Other_Solutions", "Other Solutions")

EN_STR_RES_MAP.set("ML_Cladding_Solutions", "Cladding Solutions")

EN_STR_RES_MAP.set("ML_Framing_Solutions", "Framing Solutions")

EN_STR_RES_MAP.set("ML_SNTFM", "Stud And Track Forming Machine")
EN_STR_RES_MAP.set("ML_RPFM", "Roof Panel Forming Machine")
EN_STR_RES_MAP.set("ML_OEM", "OEM")
EN_STR_RES_MAP.set("ML_AMSControls", "AMS Controls")
EN_STR_RES_MAP.set("ML_AMSControlsIntro", "AMS Controls offers the world’s best solutions for the metal forming industry.")
EN_STR_RES_MAP.set("ML_AMSControlLink", "AMS Control link")
EN_STR_RES_MAP.set("ML_AMSDealerCertification", "AMS Dealer Certification")
EN_STR_RES_MAP.set("ML_AMSPathFinderCtrls", "AMS Pathfinder Controls")
EN_STR_RES_MAP.set("ML_EclipseSoft", "Eclipse Software")
EN_STR_RES_MAP.set("ML_ContactUs", "Contact us")





//Spanish
const SPA_STR_RES_MAP = new Map
SPA_STR_RES_MAP.set("ML_Search", "Buscar");
SPA_STR_RES_MAP.set("ML_Home", "Principal")
SPA_STR_RES_MAP.set("ML_About", "Sobre nosotros")
SPA_STR_RES_MAP.set("ML_Products", "Productos")
SPA_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS", "SOLUCIONES DE FORMIA")
SPA_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS_LC", "SOLUCIONES DE FORMIA")
SPA_STR_RES_MAP.set("ML_MachineVideo", "Video de la máquina")
SPA_STR_RES_MAP.set("ML_CUPRFM", "la máquina formadora de rollo de correa de C & U")
SPA_STR_RES_MAP.set("ML_CZPRFM", "la máquina formadora de rollo de correa de C & Z")
SPA_STR_RES_MAP.set("ML_TiRFM", "Máquina formadora de rollo de azulejos")
SPA_STR_RES_MAP.set("ML_RCRFM", "Máquina formadora de rollo de tapa de canto")
SPA_STR_RES_MAP.set("ML_TuRFM", "Máquina Perfiladora de Tubos")
SPA_STR_RES_MAP.set("ML_MDRFM", "la máquina formadora de rollo de cubierta metálica")
SPA_STR_RES_MAP.set("ML_PRFM", "Máquina formadora de rollo de paneles")
SPA_STR_RES_MAP.set("ML_FM", "La màquina Plegadora")
SPA_STR_RES_MAP.set("ML_AE", "Equipo auxiliar")

SPA_STR_RES_MAP.set("ML_TE23/1100", "Línea de Losetas con Servo Prensa Dual")
SPA_STR_RES_MAP.set("ML_S_SPTL", "Servoprensa simple para azulejos")
SPA_STR_RES_MAP.set("ML_ROOFING_SOLS", "Soluciones para Techos")
SPA_STR_RES_MAP.set("ML_Other_Solutions", "Otras Soluciones")

SPA_STR_RES_MAP.set("ML_Cladding_Solutions", "Soluciones de Revestimiento")

SPA_STR_RES_MAP.set("ML_Framing_Solutions", "Soluciones para Armazón")

SPA_STR_RES_MAP.set("ML_RPFM", "Perfiladora de Panel de Techo")
SPA_STR_RES_MAP.set("ML_OEM", "OEM")
SPA_STR_RES_MAP.set("ML_AMSControls", "Controles de AMS")
SPA_STR_RES_MAP.set("ML_AMSControlsIntro", "AMS Controls ofrece las mejores soluciones del mundo para la industria de la formación de metales.")
SPA_STR_RES_MAP.set("ML_AMSControlLink", "Enlace de control AMS")
SPA_STR_RES_MAP.set("ML_AMSDealerCertification", "Certificación de distribuidor AMS")
SPA_STR_RES_MAP.set("ML_AMSPathFinderCtrls", "Controles de buscador de camino")
SPA_STR_RES_MAP.set("ML_EclipseSoft", "Software de Eclipse")
SPA_STR_RES_MAP.set("ML_ContactUs", "Contáctenos")

const DE_STR_RES_MAP = new Map
DE_STR_RES_MAP.set("ML_Search", "Suchen")
DE_STR_RES_MAP.set("ML_Home", "Startseite")
DE_STR_RES_MAP.set("ML_About", "Über uns")
DE_STR_RES_MAP.set("ML_Products", "Produkte")
DE_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS", "LÖSUNGEN von FORMIA")
DE_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS_LC", "SOLUCIONES DE FORMIA")
DE_STR_RES_MAP.set("ML_MachineVideo", "Video")
DE_STR_RES_MAP.set("ML_CUPRFM", "C&U Pfetten-Rollformmaschine")
DE_STR_RES_MAP.set("ML_CZPRFM", "C&Z Pfetten-Rollformmaschine")
DE_STR_RES_MAP.set("ML_TiRFM", "Dachplattenrollformmaschine")
DE_STR_RES_MAP.set("ML_RCRFM", "Firstkappenrollformmaschine")
DE_STR_RES_MAP.set("ML_TuRFM", "Rohrwalzenformmaschine")
DE_STR_RES_MAP.set("ML_MDRFM", "Rollformmaschine für Metallabdeckungen")
DE_STR_RES_MAP.set("ML_PRFM", "Rollformmaschine für Panele")
DE_STR_RES_MAP.set("ML_FM", "Faltmaschine")
DE_STR_RES_MAP.set("ML_AE", "Zusatzausrüstung")

DE_STR_RES_MAP.set("ML_TE23/1100", "Doppel-Servopresse-Fliesenlinie")
DE_STR_RES_MAP.set("ML_S_SPTL", "Einzel-Servo-Plattenpresslinie")
DE_STR_RES_MAP.set("ML_ROOFING_SOLS", "Dachlösungen")
DE_STR_RES_MAP.set("ML_Other_Solutions", "Andere Lösungen")

DE_STR_RES_MAP.set("ML_Cladding_Solutions", "Verkleidungslösungen")

DE_STR_RES_MAP.set("ML_Framing_Solutions", "Rahmenlösungen")

DE_STR_RES_MAP.set("ML_RPFM", "Dachplattenformmaschine")
DE_STR_RES_MAP.set("ML_OEM", "OEM (Erstausrüster)")
DE_STR_RES_MAP.set("ML_AMSControls", "AMS Steuerungen")
DE_STR_RES_MAP.set("ML_AMSControlsIntro", "AMS Steuerungen bieten weltweit die beste Lösung für die Metallumformindustrie.")
DE_STR_RES_MAP.set("ML_AMSControlLink", "AMS Steuerungslink")
DE_STR_RES_MAP.set("ML_AMSDealerCertification", "AMS Händlerzertifikation")
DE_STR_RES_MAP.set("ML_AMSPathFinderCtrls", "AMS Pathfinder-Steuerungen")
DE_STR_RES_MAP.set("ML_EclipseSoft", "Eclipse-Software")
DE_STR_RES_MAP.set("ML_ContactUs", "Kontaktieren Sie uns")

const RU_STR_RES_MAP = new Map
RU_STR_RES_MAP.set("ML_Search", "Search")//FIXME
RU_STR_RES_MAP.set("ML_Home", "Домашняя страница")
RU_STR_RES_MAP.set("ML_About", "О нас")
RU_STR_RES_MAP.set("ML_Products", "Продукция")
RU_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS", "Решение компании Formia")
RU_STR_RES_MAP.set("ML_FORMIA_SOLUTIONS_LC", "Решение компании Formia")
RU_STR_RES_MAP.set("ML_MachineVideo", "Видео о станке:")
RU_STR_RES_MAP.set("ML_CUPRFM", "Машина для вальцовочного формования обрешетки C&U")
RU_STR_RES_MAP.set("ML_CZPRFM", "Станок для вальцовочного формования обрешетки C&Z")
RU_STR_RES_MAP.set("ML_TiRFM", "Роликовая профилировочная машина")
RU_STR_RES_MAP.set("ML_RCRFM", "Станок для вальцовочного формования конькового шаблона")
RU_STR_RES_MAP.set("ML_TuRFM", "Станок для вальцовочного формования стальной трубы")
RU_STR_RES_MAP.set("ML_MDRFM", "Машина для формования металлического настила")
RU_STR_RES_MAP.set("ML_PRFM", "Станок для вальцовочного формования стеновых панелей")
RU_STR_RES_MAP.set("ML_FM", "Фальцевальная машина")
RU_STR_RES_MAP.set("ML_AE", "Вспомогательное оборудование")
RU_STR_RES_MAP.set("ML_Roofing_Solutions", "Кровельные решения")

RU_STR_RES_MAP.set("ML_TE23/1100", "Плиточная линия с двойным сервопрессом")
RU_STR_RES_MAP.set("ML_S_SPTL", "Линия для производства плитки с одним сервоприводом")
RU_STR_RES_MAP.set("ML_ROOFING_SOLS", "Кровельные решения")
RU_STR_RES_MAP.set("ML_Other_Solutions", "Другие решения")

RU_STR_RES_MAP.set("ML_Cladding_Solutions", "Облицовочные решения")

RU_STR_RES_MAP.set("ML_Framing_Solutions", "Каркасные решения")

RU_STR_RES_MAP.set("ML_SNTFM", "Шпилька и гусеничная формовочная машина")
RU_STR_RES_MAP.set("ML_RPFM", "Машина для формования кровельных плит")
RU_STR_RES_MAP.set("ML_OEM", "Фирма-изготовитель комплектного оборудования")
RU_STR_RES_MAP.set("ML_AMSControls", "Управление AMS")
RU_STR_RES_MAP.set("ML_AMSControlsIntro", "Система управления AMS предлагает лучшие в мире решения в металлоформовочной промышленности.")
RU_STR_RES_MAP.set("ML_AMSControlLink", "Ссылка на управление AMS")
RU_STR_RES_MAP.set("ML_AMSDealerCertification", "Сертификация дилера AMS")
RU_STR_RES_MAP.set("ML_AMSPathFinderCtrls", "Система управления AMS Pathfinder")
RU_STR_RES_MAP.set("ML_EclipseSoft", "Программное обеспечение Eclipse")
RU_STR_RES_MAP.set("ML_ContactUs", "Свяжитесь с нами")


const MULTI_LANG_STR_RES_MAP = new Map
MULTI_LANG_STR_RES_MAP.set("en", EN_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("spa", SPA_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("de", DE_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("ru", RU_STR_RES_MAP)

export default {
    /*
    activate() {
        console.log(this.$route)
        return new Promise((resolve) => {
            console.log('inbox activated.')
            resolve(true)
        })
    },
    */
    computed: {
        amsCtrlsActive() {
            return this.$route.name === 'amscontrols'
        },
        formiaSolsActive() {
            return this.$route.name === 'formia-solutions'
        },
        productsActive()  {
            return this.$route.name === 'products'
        }
    },
    /*
    created() {
        console.log(this.$route)
        if (this.$route.name === 'formia-solutions') {
            this.showFormiaSols()
            this.navFlags.isProducts = true
        }
    },
    */
    components: {
        VideoLink
    }, data: function() {
            var dataObj = {
                searchText: '',
                navFlags: {

					// isAMSControls: false,
                    // isProducts: false
                    // isOEM: false,
                    // isContactUs: false
                    // isNews: false
				},
                mlStrResMap: MULTI_LANG_STR_RES_MAP,
                // prodFormiaSols: false
            }

			return dataObj
		}, methods: {
            getStrRes,
            getUrlStr,
            search() {
                if (this.searchText === '') {
                    return
                }
                let st = this.searchText
                this.searchText = ''
                this.$router.go({
                    name: 'search',
                    query: {q: st}
                })
            },
			toggleActive(nID) {
                if (!nID) {
                    Object.keys(this.navFlags).forEach(function(k) {
					    this.navFlags[k] = false
				    }, this)
                    return
                }
				if (this.navFlags[nID]) {
					this.navFlags[nID] = false
					return
				}
				Object.keys(this.navFlags).forEach(function(k) {
					this.navFlags[k] = false
				}, this)
				this.navFlags[nID] = true
                this.$router.go({path: this.getUrlStr('/')})
            },
            /*
            showFormiaSols() {
                this.showProducts()
                this.prodFormiaSols = true
            },
            showProducts() {
                this.prodFormiaSols = false
            }
            */
		}
	}

</script>

<style scoped>
    .media-heading a {
        color: unset;
    }
    .media-heading {
        font-weight: bold;
    }
    .am-nav-wrap {
        border-top: 2px solid #337ab7;
        border-bottom: 2px solid #337ab7;
    }

    .am-nav-wrap h4 {
        text-align: center;
    }

    .am-nav-wrap .img-ga {
        padding: 2px;

    }

    .am-nav-wrap .image-link {
        text-align: center;
        display: block;
        margin-bottom: 1em;
        color: #555;
    }

    .expand-transition {
        transition: all .3s ease;
        padding: 10px;
        overflow: hidden;
    }

    .expand-enter, .expand-leave {
        height: 0;
        padding: 0 10px;
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// AmHeader.vue?9b9360ac